export default function removeClass(e, anchorToggle, anchorContentWrapper) {
  anchorToggle.classList.remove("open");
  anchorContentWrapper.classList.remove("open");
}
